import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PoliciessService extends BaseService {
  baseUrl = environment.apiUrl + 'Policies';
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    super(http, authenticationSerives, environment.apiUrl + 'Policies');
  }

  getPublicPolicies() {
    return this.http.get<Tree>(this.baseUrl + '/publicPolicy');
  }
}
